import { gql } from '@apollo/client';

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CreateCompanyRequest!) {
    createCompany(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyRequest!) {
    updateCompany(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const SOFT_DELETE_COMPANY = gql`
  mutation SoftDeleteCompany($input: SoftDeleteCompanyRequest!) {
    softDeleteCompany(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;
